class MC_TabsSchool {
 constructor() {
  this.TabsSchool();
  this.scroolMenuFixed();
  this.filterBook();
 }

 TabsSchool() {
  let segmentButton = document.querySelectorAll('.segment-button');
  let segment = document.querySelectorAll('.segment');
  let inputMobile = document.querySelector('.input-mobile');
  let categories = document.querySelector('.categories');
  if (!segmentButton || !segment || !inputMobile || !categories) {
   return;
  }

  for (let i = 0; i < segmentButton.length; i++) {
   segmentButton.forEach((link) => {
    link.addEventListener('click', function () {
     let href = link.getAttribute('data-segment-id');
     let offsetTop = categories.getBoundingClientRect().top;
     let btsBannerHeight = document.querySelector('.bts-banner-2021').getBoundingClientRect().height
     let positionStop = document.querySelector('#header').getBoundingClientRect().height;
     let scrollTopPosition = (window.scrollY - btsBannerHeight - positionStop);
     let scrollPosition = offsetTop - positionStop;
     if(document.querySelector('.bts-menu').getBoundingClientRect().bottom <= 183) {
      window.scrollBy({
       top: (-scrollTopPosition),
       behavior: 'smooth',
      })
     } else {
      window.scrollBy({
       top: scrollPosition,
       behavior: 'smooth',
      })
     }

     segmentButton.forEach(element => {
      element.classList.remove('active');
      element.classList.add('not-active');
     })

     segment.forEach(section => {
      section.classList.remove('active');
     })

     document.querySelector(`.segment-button[data-segment-id="${href}"]`).classList.add('active');
     document.querySelector(`.segment-button[data-segment-id="${href}"]`).classList.remove('not-active');
     document.querySelector(`.segment-${href}`).classList.add('active');

     categories.classList.remove('active');
     let text_item = document.querySelector(`.segment-button[data-segment-id="${href}"]`).querySelector('.segment-button__text').innerHTML;
     inputMobile.innerHTML = text_item;
    })
   })
  }

  inputMobile.addEventListener('click', function (e) {
   e.preventDefault();
   categories.classList.toggle('active');
  })
 }

 scroolMenuFixed() {
  $(window).on('scroll', function () {
   var offset = $(window).scrollTop();
   var banner_big = $('.bts-banner-2021').outerHeight();
   var menu_header = $('#header').outerHeight();
   var positionOffSet = banner_big + menu_header;
   var page_menu = $('.bts-menu');
   if (offset > (positionOffSet + 250)) {
    page_menu.addClass('sticky');
    page_menu.css('top', `${menu_header}px`);
   }
   else {
    page_menu.removeClass('sticky');
    page_menu.css('top', 'initial');
   }
  }).scroll();
 }

 filterBook() {
  let filterWrapper = document.querySelectorAll('.input-button-flex');
  if (!filterWrapper.length) {
   return
  };

  for (let index = 0; index < filterWrapper.length; index++) {
   let butttonDownloadFile = filterWrapper[index].querySelector('.download-file');
   let contentItem = filterWrapper[index].querySelector('.filter');
   let contentTextItem = contentItem.querySelector('SPAN');
   let dropDownMenuItems = filterWrapper[index].querySelectorAll('.dropdown LI');
   let dropDownMenuItemsTitle = filterWrapper[index].querySelectorAll('.dropdown LI .title');

   contentItem.addEventListener('click', function (e) {
    e.preventDefault();
    contentItem.classList.toggle('active');
   });

   for (let i = 0; i < dropDownMenuItems.length; i++) {
    dropDownMenuItems[i].addEventListener('click', function (e) {
     e.preventDefault();
     contentItem.classList.remove('active');
     let hrefBook = dropDownMenuItems[i].getAttribute('data-link');
     butttonDownloadFile.href = hrefBook;
     contentTextItem.innerHTML = dropDownMenuItemsTitle[i].innerHTML;
    });
   };
  }
 }
};
